export default "__VITE_ASSET__9b07078c__"